import React, { memo, useState } from 'react';
import { Stack, Icon, Typography } from 'investira.react.components';

const AvaliadoCheck = memo(props => {
  const { disabled = false, onChange, checked, defaultChecked = false } = props;
  const [xAvaliado, setXAvaliado] = useState(Boolean(defaultChecked));
  const isControlled = typeof checked === 'boolean';
  const isAvaliado = isControlled ? checked : xAvaliado;

  const handleToggleAvaliado = e => {
    e.stopPropagation();
    e.preventDefault();

    const nextAvaliado = !isAvaliado;

    if (!isControlled) {
      setXAvaliado(nextAvaliado);
    }

    if (typeof onChange === 'function') {
      onChange(nextAvaliado, e);
    }
  };

  return (
    <Stack
      onClick={e => handleToggleAvaliado(e)}
      sx={{
        pointerEvents: disabled ? 'none' : 'auto',
        cursor: disabled ? 'default' : 'pointer'
      }}>
      <Stack
        gap={0.5}
        direction="row"
        sx={{
          backgroundColor: disabled ? 'secondary.main' : 'primary.main',
          alignItems: 'center',
          borderRadius: 1.5,
          pr: 1,
          pl: 0.5,
          opacity: disabled ? 0.7 : 1,
          border: '1px solid',
          borderColor: disabled ? 'secondary.main' : 'primary.main'
        }}>
        <Icon
          iconName={isAvaliado ? 'option_select' : 'option'}
          color={disabled ? 'textSecondary' : 'secondary'}
          size={21}
        />
        <Typography
          variant="caption"
          color={disabled ? 'textSecondary' : 'secondary.main'}
          sx={{ fontWeight: 600 }}>
          {isAvaliado ? 'Revisado' : 'Revisar'}
        </Typography>
      </Stack>
    </Stack>
  );
});

export default AvaliadoCheck;
